import { createFileRoute } from '@tanstack/react-router'

import { OnlineSalesReport } from '@/components/reports/online-sales/online-sales-report'
import { ReportPage } from '@/components/reports/report-page'
import { m } from '@/lib/paraglide/messages'
import { requireShopEnabled } from '@/lib/shop-module'
import { queryClient } from '@/router'

// Báo cáo › Website (hợp đồng v3 §14.7, wireframe ErpBaoCaoWebsite).
export const Route = createFileRoute('/_app/_authed/_sidebar/reports/website')({
    // Báo cáo kênh bán lẻ: chỉ khi SHOP_ENABLED (như menu + API).
    beforeLoad: () => requireShopEnabled(queryClient),
    component: WebsiteReportPage,
})

function WebsiteReportPage() {
    return (
        <ReportPage title={m.online_report_title_web()}>
            <OnlineSalesReport channel="web" />
        </ReportPage>
    )
}
